'use strict';

positivePaySetupController.$inject = ['$scope', '$uibModalInstance', '$q', 'positivePayService', 'dialogHelper', 'BUSY_MESSAGE'];

angular.module('schoolLinqApp').controller('positivePaySetupController', positivePaySetupController);

function positivePaySetupController($scope, modalInstance, $q, positivePayService, dialogHelper, BUSY_MESSAGE) {
	$scope.bankId = $scope.$parent.vm.selectedBank.Id;

	$scope.vm = getViewModel();

	$scope.fieldsBusy = {
		message: BUSY_MESSAGE.Loading,
		promise: loadFields($scope.vm),
	};

	$scope.formBusy = {
		message: BUSY_MESSAGE.Loading,
		promise: loadBankSetup($scope.vm),
	};

	$scope.fileTypeEnum = fileTypeEnum;
	$scope.delimiterEnum = delimiterEnum;
	$scope.dateFormatEnum = dateFormatEnum;
	$scope.fieldTabEnum = fieldTabEnum;
	$scope.sectionTabEnum = sectionTabEnum;
	$scope.leftRightEnum = leftRightEnum;
	$scope.padCharacterEnum = padCharacterEnum;

	function getViewModel() {
		var model = {
			fieldTab: fieldTabEnum.Bank,
			fields: {},
			activeField: null,
			activeFields: [],
			sectionTab: sectionTabEnum.Detail,
			includeHeader: false,
			includeFooter: false,
			formValues: {
				BankId: $scope.bankId,
				FileType: fileTypeEnum.FixedLength,
				RecordLength: 0,
				Delimiter: ',',
				DateFormat: dateFormatEnum.YYYYMMDD,
				PVBankId: 0,
			},
			draggableOptions: {
				connectWith: '#sectionfields-sortable',
			},
			sortableOptions: {
				handle: '.sort-handle',
				cursor: 'move',
				delay: 200,
				forcePlaceholderSize: true,
				opacity: 0.8,
				placeholder: 'ui-sortable-placeholder',
				revert: true,
				receive: function (e, ui) {
					//need to apply transforms before adding to the new list
					//so cancel the native drop and add our own instead
					ui.item.sortable.cancel();

					handleFieldDoubleClick(model, null, ui.item.scope().field, ui.item.sortable.dropindex);
				},
				stop: function () {
					$scope.positivePayForm.$setDirty();
				},
			},
			isReadOnly: $scope.$parent.vm.isReadOnly,
		};

		model.formValues[sectionTabEnum.Header] = [];
		model.formValues[sectionTabEnum.Detail] = [];
		model.formValues[sectionTabEnum.Footer] = [];

		function getActiveClass(model, key, value) {
			var classes = { active: model[key] === value };

			//this kinda smells but it's easier than refactoring
			var disabledFields = {
				UpdateType: true,
				UpdateType2: true,
				TransactionCode: true,
			};

			if ((key === 'fieldTab' && value === fieldTabEnum.Check) || (key === 'activeField' && disabledFields[value])) {
				classes.disabled = model.sectionTab !== sectionTabEnum.Detail;
			}

			return classes;
		}

		function getRecordTotal(model) {
			var sum = 0;

			var sectionFields = model.formValues[model.sectionTab];

			for (var i = 0; i < sectionFields.length; i++) {
				sum += parseInt(sectionFields[i].ColumnLength, 10) || 0;
			}

			return sum;
		}

		function getActiveFields(model) {
			var active = _.filter(model.fields, function (field) {
				return field.TableName === model.fieldTab;
			});

			return active;
		}

		function getSubmitDisabled(model) {
			var disabled = $scope.positivePayForm.$invalid || ($scope.positivePayForm.$pristine && _.isEqual(model.formValues, bankResponse));

			return disabled;
		}

		function setFieldTab(model, tab) {
			if (tab === fieldTabEnum.Check && model.sectionTab !== sectionTabEnum.Detail) {
				return;
			}

			model.fieldTab = tab;
		}

		function setSectionTab(model, tab) {
			model.sectionTab = tab;

			if (tab !== sectionTabEnum.Detail && model.fieldTab === fieldTabEnum.Check) {
				setFieldTab(model, fieldTabEnum.Bank);
			}
		}

		function handleDelimiterAdd(value) {
			var character = value.substr(0, 5);
			return { key: character, value: character };
		}

		function handleFieldClick(model, event, field) {
			if (event.target.classList.contains('disabled')) {
				return;
			}

			model.activeField = field.ColumnName;
		}

		function handleFieldDoubleClick(model, event, field, index) {
			if (event && event.target.classList.contains('disabled')) {
				return;
			}

			var clone = _.clone(field);

			//set datetime column lengths to match date format
			if (clone.ColumnType === 'DateTime') {
				var curFormat = parseInt(model.formValues.DateFormat, 10);

				for (var format in dateFormatEnum) {
					if (curFormat === dateFormatEnum[format]) {
						clone.ColumnLength = format.length;
						break;
					}
				}
			}

			if (index === null || index === undefined) {
				model.formValues[model.sectionTab].push(clone);
			} else {
				model.formValues[model.sectionTab].splice(index, 0, clone);
			}
		}

		function handleFieldDelete(model, index) {
			model.formValues[model.sectionTab].splice(index, 1);
		}

		function handleFieldMove(model, index, direction) {
			var removed = model.formValues[model.sectionTab].splice(index, 1);

			model.formValues[model.sectionTab].splice(index + direction, 0, removed[0]);
		}

		function handlePayeeValidationChange(model) {
			model.includeFooter = true;
			model.includeHeader = true;
		}

		function handleIncludeCheckboxChange(model) {
			if (
				(model.sectionTab === sectionTabEnum.Header && !model.includeHeader) ||
				(model.sectionTab === sectionTabEnum.Footer && !model.includeFooter)
			) {
				model.sectionTab = sectionTabEnum.Detail;
			}
		}

		function handlePadCharacterAdd(value) {
			var character = value.substr(0, 1);
			return { key: character, value: character };
		}

		function handleCancel() {
			if (!$scope.positivePayForm.$pristine) {
				dialogHelper.yesnoMessageBox(
					'Are you sure you want to cancel?',
					'Your changes will not be saved',
					null,
					'Warning',
					modalInstance.close
				);

				return;
			}

			modalInstance.close();
		}

		function handleSubmit(model) {
			var body = _.clone(model.formValues);

			if (!model.includeHeader) {
				body.Header = [];
			}

			if (!model.includeFooter) {
				body.Footer = [];
			}

			var promise = positivePayService
				.postSetup(body)
				.then(function (response) {
					if (!response.data.IsValid) {
						return $q.reject(response.data.errors);
					}

					dialogHelper.openMessageBox('Positive Pay information saved successfully', '', null, 'Info');

					modalInstance.close();
				})
				.catch(function (errors) {
					dialogHelper.openMessageBox('Unable to save Positive Pay information', errors.join(' '), null, 'Error');
				});

			$scope.formBusy = {
				message: BUSY_MESSAGE.Saving,
				promise: promise,
			};
		}

		return angular.extend(model, {
			getActiveClass: _.partial(getActiveClass, model),
			getRecordTotal: _.partial(getRecordTotal, model),
			getActiveFields: _.partial(getActiveFields, model),
			getSubmitDisabled: _.partial(getSubmitDisabled, model),
			setFieldTab: _.partial(setFieldTab, model),
			setSectionTab: _.partial(setSectionTab, model),
			handleDelimiterAdd: handleDelimiterAdd,
			handleFieldClick: _.partial(handleFieldClick, model),
			handleFieldDoubleClick: _.partial(handleFieldDoubleClick, model),
			handleFieldDelete: _.partial(handleFieldDelete, model),
			handleFieldMove: _.partial(handleFieldMove, model),
			handlePayeeValidationChange: _.partial(handlePayeeValidationChange, model),
			handleIncludeCheckboxChange: _.partial(handleIncludeCheckboxChange, model),
			handlePadCharacterAdd: handlePadCharacterAdd,
			handleCancel: handleCancel,
			handleSubmit: _.partial(handleSubmit, model),
		});
	}

	function loadFields(model) {
		var promise = positivePayService.getFields().then(_.partial(finishedLoadingFields, model));

		function finishedLoadingFields(model, response) {
			model.fields = response.data.fields;
		}

		return promise;
	}

	var bankResponse;

	function loadBankSetup(model) {
		var promise = positivePayService.getSetup($scope.bankId).then(_.partial(finishedLoadingBankSetup, model));

		function finishedLoadingBankSetup(model, response) {
			if (response.data.setup) {
				_.assign(model.formValues, response.data.setup);
				bankResponse = JSON.parse(JSON.stringify(response.data.setup));

				var isPV = response.data.setup.FileType === fileTypeEnum.PayeeValidation;

				model.includeHeader = isPV || response.data.setup.Header.length > 0;
				model.includeFooter = isPV || response.data.setup.Footer.length > 0;
			}
		}

		return promise;
	}
}

//enums
var fileTypeEnum = {
	FixedLength: 0,
	Delimited: 1,
	PayeeValidation: 2,
};

var delimiterEnum = {
	'Comma (,)': ',',
	'Quoted comma (",")': '","',
	'Pipe (|)': '|',
	'Tab (\t)': '\t',
};

var dateFormatEnum = {
	YYYYMMDD: 0,
	MMDDYYYY: 1,
	MMDDYY: 2,
	'MM/DD/YYYY': 3,
	'MM/DD/YY': 4,
	'YYYY-MM-DD': 5,
	'MM-DD-YYYY': 6,
	'MM-DD-YY': 7,
};

var fieldTabEnum = {
	Bank: 'Bank',
	Check: 'OutstandingChecks',
	Standard: null,
};

var sectionTabEnum = {
	Header: 'Header',
	Detail: 'Detail',
	Footer: 'Footer',
};

var leftRightEnum = {
	Left: 'L',
	Right: 'R',
};

var padCharacterEnum = {
	Blank: ' ',
	Zero: '0',
};
